var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4d84885a11fbe40f22058c3b656e7c8a822861a0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["manezz@jef-jaeken"]={id:"4d84885a11fbe40f22058c3b656e7c8a822861a0"};
      